module.exports = __webpack_public_path__ + "sprite_97_C.2e58f17ebda2c6c2f5c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/sprite_97_C.svg
// module id = ./src/icons/sprite_97_C.svg
// module chunks = styles